import {useMemo} from 'react';
import {PixelRatio, Platform} from 'react-native';

export const useIsSmallScreenDevice = () => {
  const density = PixelRatio.get();
  return useMemo(() => density <= 2 && Platform.OS !== 'web', [density]);
};
